import { HTMLAttributes, ReactNode, RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { useLenis } from '@/contexts/lenis'

import { cn } from '@/lib/utils'

type MediaParallaxProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  fill?: boolean
  // eslint-disable-next-line no-unused-vars
  children: (ref: RefObject<HTMLElement>) => ReactNode
}

const MediaParallax = ({
  children,
  className,
  fill = false,
  ...props
}: MediaParallaxProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const media = useRef<HTMLImageElement>(null)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis || !media.current) return

      gsap.to(media.current, {
        scrollTrigger: {
          trigger: media.current,
          start: 'top 100%',
          end: 'bottom 0%',
          markers: false,
          scrub: true,
          once: false
        },
        yPercent: -13,
        ease: 'none'
      })
    },
    { scope: media, dependencies: [lenis] }
  )

  return (
    <span
      ref={ref}
      className={cn(
        'translate isolate overflow-hidden [&_img]:!h-[115%] [&_video]:!h-[115%]',
        {
          'relative block': !fill,
          'absolute left-0 top-0 h-full w-full': fill
        },
        className
      )}
      {...props}
    >
      {children(media)}
    </span>
  )
}

export default MediaParallax
